export enum SkillCollectionFileName {
  SkillMd = "SKILL.md",
  AgentsMd = "AGENTS.md",
  ClaudeMd = "CLAUDE.md",
  OpenclawJson = "openclaw.json",
}

export enum SkillCollectionImportPrefix {
  Openclaw = ".openclaw/",
}

export const OPENAI_YAML_SUBPATH = "agents/openai.yaml";

export const OPENCLAW_SKILL_ROOT = "skills";

export const FRONTMATTER_KEY_NAME = "name";
export const FRONTMATTER_KEY_DESCRIPTION = "description";
export const FRONTMATTER_KEY_DISABLE_MODEL_INVOCATION = "disable-model-invocation";

export const DEFAULT_SKILL_NAME = "Skill";
export const DEFAULT_SKILL_DESCRIPTION = "Skill description";
export const DEFAULT_EXAMPLE_SKILL_NAME = "example-skill";
export const DEFAULT_EXAMPLE_SKILL_DESCRIPTION =
  "Example skill. Use when the user needs help with example tasks.";
